import { render, staticRenderFns } from "./AMisRenderer.vue?vue&type=template&id=fa1d70d6&scoped=true"
import script from "./AMisRenderer.vue?vue&type=script&lang=js"
export * from "./AMisRenderer.vue?vue&type=script&lang=js"
import style0 from "./AMisRenderer.vue?vue&type=style&index=0&id=fa1d70d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1d70d6",
  null
  
)

export default component.exports